import { render, staticRenderFns } from "./brigad_zar.vue?vue&type=template&id=a288dd2c&scoped=true&"
import script from "./brigad_zar.vue?vue&type=script&lang=js&"
export * from "./brigad_zar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a288dd2c",
  null
  
)

export default component.exports